<template>
    <div>
        <div class="pre-loading" />
    </div>
</template>

<script>
import AuthService from '~/services/AuthService';
import MessageService from '~/services/MessageService';

export default {
    name: 'Redirect',
    methods: {
        handleAuthentication() {
            // Extract authCode and provider from query
            let query = Object.assign({}, this.$route.query);
            let authCode = query.code;
            let provider = query.provider; // Facebook, Google...etc

            if (!authCode || !provider) {
                this.backToHome(query.redirectUrl);
                return;
            }

            if (authCode instanceof Array && authCode.length > 0) {
                authCode = authCode[0];
            }
            if (provider instanceof Array && provider.length > 0) {
                provider = provider[0];
            }

            AuthService.authenticate(authCode, provider)
                .then(tokens => {
                    this.backToHome(query.redirectUrl);
                })
                .catch(err => {
                    this.backToHome(query.redirectUrl);
                    MessageService.error('Was not able to login', err);
                });
        },
        backToHome(path) {
            this.$router.push({ path: path || '/' });
        },
    },
    mounted() {
        // Check if auth code and provider is in query, if so attempt to authenticate
        this.handleAuthentication();
        this.$interfaces.logInModule.setDisabledPopup();
    },
};
</script>

<style scoped>
.pre-loading {
    display: inline-block;
    width: 110px;
    height: 110px;
    position: absolute;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
}
.pre-loading:after {
    content: ' ';
    display: block;
    width: 96px;
    height: 96px;
    /* margin: 1px; */
    border-radius: 50%;
    border: 7px solid #c50230;
    border-color: #c50230 transparent #c50230 transparent;
    animation: pre-loading 1.2s linear infinite;
}
@keyframes pre-loading {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
